export enum UserPermission {
  ViewHome = 'ViewHome',
  EditHome = 'EditHome',
}
